<template>
  <div
    class="community-group-thumbnail community-group-thumbnail__image"
    :style="style"
  ></div>
</template>

<script lang="ts">
export default {
  name: 'StudioCommunityGroupThumbnail',
  props: {
    group: {
      type: Object as () => CommunityGroupsResponse,
      required: true,
    },
  },
  computed: {
    style(): object | null {
      if (this.group.thumbnail_photo) {
        const thumbnailUrl = this.group.thumbnail_photo.thumbnail;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      if (this.group.cover_photo) {
        const thumbnailUrl = this.group.cover_photo.thumbnail;
        return {
          backgroundImage: 'url(' + thumbnailUrl + ')',
          backgroundSize: 'cover',
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.community-group-thumbnail {
  &__image {
    border-radius: $border-radius;
    background-position: center center;
    background-size: auto 65%;
    background-repeat: no-repeat;
    background-color: var(
      --brand-color-with-opacity-03,
      rgba($light-bubblegum, 0.3)
    );
    object-fit: cover;
    transition: all 0.3s ease-in-out;
  }
}
</style>
